export enum DocumentReferenceType
{
    Bill = 1,
    Truck = 2,
    Consignee = 3,
}